// ReactJS
import React from 'react';
import { connect } from 'react-redux';

// Services
import {} from '../../services/paymentProviders';

// Components
import PaymentProviders from '../../components/PaymentProviders';
import LimitedFreemiumPlan from '../../components/LimitedFreemiumPlan';

const PaymentProvidersPage = ({ storeId, storeData }) => {
    return (
        <div style={{ position: 'relative' }}>
            <PaymentProviders storeId={storeId} />
            {storeData.plan_features.is_payment_checkouts_enabled === false && (
                <LimitedFreemiumPlan type="payment" />
            )}
        </div>
    );
};

const mapStateToProps = ({ auth, common }) => ({
    storeId: auth.storeId,
    storeData: common.storeData,
});

export default connect(mapStateToProps)(PaymentProvidersPage);
